import { useMutation, useQueryClient } from 'react-query';

import client from 'client';
import { MeetingsHttpKey } from '../ManageMeetings/useMeetingsData';
import { ScheduledMeetingResponse } from './useScheduledMeetings';

type SelectTimes = {
    selectedTimes: Date[];
    timezone: string;
};

const selectTimes = async ({
    eventId,
    meetingId,
    payload,
}: {
    eventId: number;
    meetingId: string;
    payload: SelectTimes;
}) => {
    const response = await client().post<ScheduledMeetingResponse>(
        `/api/v2/meetings/events/${eventId}/scheduledMeetings/${meetingId}/selectTimes`,
        payload
    );
    return response.data;
};

const useSelectTimes = () => {
    const queryClient = useQueryClient();

    return useMutation(selectTimes, {
        onMutate: () => {
            queryClient.cancelQueries(MeetingsHttpKey.Meetings);
            queryClient.cancelQueries(MeetingsHttpKey.MeetingsTotal);
            queryClient.cancelQueries(MeetingsHttpKey.MeetingsGroups);
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries(MeetingsHttpKey.Meetings);
            await queryClient.invalidateQueries(MeetingsHttpKey.MeetingsTotal);
            queryClient.invalidateQueries(MeetingsHttpKey.MeetingsGroups);
        },
        useErrorBoundary: true,
    });
};

export default useSelectTimes;
